import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[ PaymentV2 ]';

const Actions = {
	setPaymentProduct: `${MODULE_PREFIX} setPaymentProduct`,
	setPaymentDetails: `${MODULE_PREFIX} setPaymentDetails`,
    setPaymentFlow: `${MODULE_PREFIX} setPaymentFlow`,
    setOrderCreationData: `${MODULE_PREFIX} setOrderCreationData`,
	resetPaymentDetails: `${MODULE_PREFIX} resetPaymentDetails`,
	fetchNeftDetails: `${MODULE_PREFIX} fetchNeftDetails`,
	setNeftDetails: `${MODULE_PREFIX} setNeftDetails`,
	setShowPaymentRedirectionLoader: `${MODULE_PREFIX} setShowPaymentRedirectionLoader`,
	setShowPaymentFailureSheet: `${MODULE_PREFIX} setShowPaymentFailureSheet`,
	setshowPaymentCancellationSheet: `${MODULE_PREFIX} setshowPaymentCancellationSheet`,
	setSelectedPaymentMethodDetails: `${MODULE_PREFIX} setSelectedPaymentMethodDetails`,
	fetchVpaValidation: `${MODULE_PREFIX} fetchVpaValidation`,
	fetchMfVpaValidation: `${MODULE_PREFIX} fetchMfVpaValidation`,
	setBankDetails: `${MODULE_PREFIX} setBankDetails`,
	setMfInvestmentData: `${MODULE_PREFIX} setMfInvestmentData`,
	setShowBankOptionsSheet: `${MODULE_PREFIX} setShowBankOptionsSheet`,
	setPrimaryBankDetails: `${MODULE_PREFIX} setPrimaryBankDetails`,
};

export const setPaymentProduct = createAction(Actions.setPaymentProduct);
export const setPaymentDetails = createAction(Actions.setPaymentDetails);
export const setPaymentFlow = createAction(Actions.setPaymentFlow);
export const setOrderCreationData = createAction(Actions.setOrderCreationData);
export const fetchNeftDetails = createAction(Actions.fetchNeftDetails);
export const setNeftDetails = createAction(Actions.setNeftDetails);
export const resetPaymentDetails = createAction(Actions.resetPaymentDetails);
export const setShowPaymentRedirectionLoader = createAction(Actions.setShowPaymentRedirectionLoader);
export const setShowPaymentFailureSheet = createAction(Actions.setShowPaymentFailureSheet);
export const setshowPaymentCancellationSheet = createAction(Actions.setshowPaymentCancellationSheet);
export const setSelectedPaymentMethodDetails = createAction(Actions.setSelectedPaymentMethodDetails);
export const fetchVpaValidation = createAction(Actions.fetchVpaValidation);
export const setBankDetails = createAction(Actions.setBankDetails);
export const setMfInvestmentData = createAction(Actions.setMfInvestmentData);
export const fetchMfVpaValidation = createAction(Actions.fetchMfVpaValidation);
export const setShowBankOptionsSheet = createAction(Actions.setShowBankOptionsSheet);
export const setPrimaryBankDetails = createAction(Actions.setPrimaryBankDetails);

export const getPaymentDetails = (state) => {
	const paymentDetails = get(state, 'paymentV2.paymentDetails', {});
	return paymentDetails;
};

export const getPaymentOptions = (state) => {
	const paymentOption = get(state, 'paymentV2.paymentDetails.supported_payment_options', []);
	return paymentOption;
};

export const getSupportedBankLists = (state) => {
	const banks = get(state, 'paymentV2.paymentDetails.bank_list', []);
	return banks;
};

export const getSelectedPaymentFeatureName = (state) => {
	const productName = get(state, 'paymentV2.paymentDetails.feature_name', '');
	return productName;
};

export const getPaymentUpiList = (state) => {
	const upiLists = get(state, 'paymentV2.paymentDetails.upi', []);
	return upiLists;
};

export const getPaymentVpaIds = (state) => {
    const vpaIds = get(state, 'paymentV2.paymentDetails.vpaIds', []);
    return vpaIds;
}

export const getOrderCreationData = (state) => {
    const orderCreationData = get(state, 'paymentV2.paymentDetails.upiData', {});
    return orderCreationData;
}

export const getPaymentAmount = (state) => {
	const paymentAmount = get(state, 'paymentV2.paymentDetails.amount', {});
    return paymentAmount;
}

export const getPaymentUrl = (state) => {
	const paymentUrl = get(state, 'paymentV2.paymentDetails.payment_url', '');
	return paymentUrl;
}

export const getShowPaymentRedirectionLoader = (state) => {
  const showPaymentRedirectionLoader = get(state, 'paymentV2.showPaymentRedirectionLoader', false);
  return showPaymentRedirectionLoader;
}

export const getShowPaymentCancellationSheet = (state) => {
  const showPaymentCancellationSheet = get(state, 'paymentV2.showPaymentCancellationSheet', false);
  return showPaymentCancellationSheet;
}

export const getShowPaymentFailureSheet = (state) => {
 const paymentFailureSheet = get(state, 'paymentV2.showPaymentFailureSheet', false);
 return paymentFailureSheet;
}

export const getSelectedPaymentMethodDetails = (state) => {
	const paymentMethodDetails = get(state, 'paymentV2.selectedPaymentMethodDetails', {});
	return paymentMethodDetails;
}

export const getPaymentNeftDetails = (state) => {
	const paymentNeftDetails = get(state, 'paymentV2.neftDetails', {});
	return paymentNeftDetails;
}

export const getPaymentBankDetails = (state) => {
	const bankDetails =  get(state, 'paymentV2.bankDetails', {});
	return bankDetails;
}

export const getMfInvestmentData = (state) => {
	const mfInvestmentData = get(state, 'paymentV2.mfInvestmentData', {});
	return mfInvestmentData;
}

export const getPaymentProduct = (state) => {
	const paymentProduct = get(state, 'paymentV2.paymentProduct', '');
	return paymentProduct;
}

export const getShowBankOptionsSheet = (state) => {
	const showBankOptionsSheet = get(state, 'paymentV2.showBankOptionsSheet', false);
	return showBankOptionsSheet;
}

export const getPaymentFlow = (state) => {
	const paymentFlow = get(state, 'paymentV2.paymentFlow', '');
	return paymentFlow;
}

export const getPaymentPrimaryBankDetails = (state) => {
	const primaryBankDetails = get(state, 'paymentV2.primaryBankDetails', {});
	return primaryBankDetails;
}

const initialState = {
	paymentDetails: {},
	paymentProduct: '',
    paymentFlow: '',
	neftDetails: {},
	showPaymentRedirectionLoader: false,
	showPaymentFailureSheet: false,
	showPaymentCancellationSheet: false,
	showBankOptionsSheet: false,
	selectedPaymentMethodDetails: {},
	bankDetails: {},
	mfInvestmentData: {},
	primaryBankDetails: {},
};

export default createReducer(initialState, (builder) => {
	builder.addCase(setPaymentDetails, (state, action) => {
		state.paymentDetails = action.payload;
	});
	builder.addCase(setPaymentProduct, (state, action) => {
		state.paymentProduct = action.payload;
	});
    builder.addCase(setPaymentFlow, (state, action) => {
        state.paymentFlow = action.payload;
    });
    builder.addCase(setOrderCreationData, (state, action) => {
        const paymentDetails = get(state, 'paymentDetails', {});
        const orderCreationData = action.payload;
        state.paymentDetails = {...paymentDetails, upiData: orderCreationData}
    });
	builder.addCase(resetPaymentDetails, (state) => {
		state.paymentDetails = {};
		state.showPaymentRedirectionLoader = false;
		state.showPaymentFailureSheet = false;
		state.showPaymentCancellationSheet = false;
		state.mfInvestmentData = {};
		state.bankDetails = {};
	});
	builder.addCase(setNeftDetails, (state, action) => {
        state.neftDetails = action.payload;
	});
	builder.addCase(setShowPaymentRedirectionLoader, (state, action) => {
		state.showPaymentRedirectionLoader = action.payload
	})
	builder.addCase(setShowPaymentFailureSheet, (state, action) => {
		state.showPaymentFailureSheet = action.payload;
	})
	builder.addCase(setshowPaymentCancellationSheet, (state, action) => {
		state.showPaymentCancellationSheet = action.payload
	})
	builder.addCase(setSelectedPaymentMethodDetails, (state, action) => {
		state.selectedPaymentMethodDetails = action.payload;
	});
	builder.addCase(setBankDetails, (state, action) => {
		state.bankDetails = action.payload;
	});
	builder.addCase(setMfInvestmentData, (state, action) => {
		state.mfInvestmentData = action.payload;
	});
	builder.addCase(setShowBankOptionsSheet, (state, action) => {
		state.showBankOptionsSheet = action.payload;
	});
	builder.addCase(setPrimaryBankDetails, (state, action) => {
		state.primaryBankDetails = action.payload;
	})
});
